import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { SHIMMER_KEYFRAMES, shimmerAfterSx } from './skeletonShimmer';

const bar = (width: number | string, height: number, opacity = 0.3) => ({
  width,
  height,
  borderRadius: 1,
  backgroundColor: '#2F3336',
  opacity,
});

const ProfileHeaderSkeleton: React.FC = () => {
  return (
    <Box
      component={motion.div}
      aria-hidden
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      sx={{
        position: 'relative',
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid #2F3336',
        backgroundColor: '#16181C',
        mb: 3,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          height: { xs: 96, sm: 128 },
          backgroundColor: '#0F1419',
          overflow: 'hidden',
          ...SHIMMER_KEYFRAMES,
          '&::after': shimmerAfterSx(0),
        }}
      />
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          px: 2,
          pb: 2,
          pt: 0,
          alignItems: 'flex-start',
          mt: { xs: -4, sm: -5 },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            width: { xs: 64, sm: 80 },
            height: { xs: 64, sm: 80 },
            borderRadius: '50%',
            border: '3px solid #000',
            backgroundColor: '#2F3336',
            ...SHIMMER_KEYFRAMES,
            '&::after': shimmerAfterSx(0.1),
          }}
        />
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            pt: { xs: 6, sm: 7 },
            pb: 0.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Box sx={bar(160, 20, 0.35)} />
          <Box sx={bar(100, 14, 0.25)} />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 3,
          px: 2,
          pb: 2,
          pt: 2,
          flexWrap: 'wrap',
          borderTop: '1px solid #2F3336',
        }}
      >
        <Box sx={bar(64, 14)} />
        <Box sx={bar(80, 14)} />
        <Box sx={bar(72, 14)} />
      </Box>
    </Box>
  );
};

export default ProfileHeaderSkeleton;
